module.exports = __webpack_public_path__ + "img/120.d3d27c2e.jpg";